import Project1 from "../Components/Projects/Project1"
import Project2 from "../Components/Projects/Project2"
import Project3 from "../Components/Projects/Project3" 

const Projects = () => {
    return (
        <div>
            <Project1 />
            <Project2 />
            <Project3 />
        </div>
    )
}

export default Projects